import React from 'react';
/*import moment from 'moment';*/

export default class MaintenanceRequestRow extends React.Component {
  render() {
    const RowData = this.props.RowData;
    /*let repeating = null;
    
    if(RowData.IsRepeating === 'Yes') {
      repeating = RowData.RepeatPeriod+' '+RowData.RepeatType;
    } else {
      repeating = '-';
    }*/

    return (
      <tr>
        <td>{RowData.Service.Name}</td>
        <td>{RowData.Description}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/MaintenanceRequestList/MaintenanceRequestRow.js